import React from 'react';
import block from 'bem-cn';
import { useSelector } from 'react-redux';
import Select from 'react-select'

import './Input.scss';

const Input = (
  {
    value,
    name,
    callBack = f => f,
    placeholder = '',
    size = 'default',
    type = 'text',
    isRequired,
    options = [],
    unBorder,
    centerText,
    label,
    notNeedDefaultValue = false,
    ...props
  }) => {
  const { locale } = useSelector(state => state.locale);
  const b = block('input');
  
  // Checking for an input or selector
  return type === 'select' ?
    <Select
      onChange={opt => callBack(opt.value)}
      styles={customStyles}
      options={
        !notNeedDefaultValue ? [
          { value: null, label: locale.notSelected },
          ...Object.entries(options).map(t => ({ value: t[0], label: locale[t[1]] ? locale[t[1]] : t[1] }))
        ] : Object.entries(options).map(t => ({ value: t[0], label: locale[t[1]] ? locale[t[1]] : t[1] }))}
    /> : type === 'textarea' ?
        <textarea
          type={type}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          onChange={e => callBack(e.currentTarget.value)}
          className={b({ sizable: size, type })}
          required={isRequired}
          {...props}
        />
    : <React.Fragment>
        <input
          type={type}
          name={name}
          value={value}
          placeholder={placeholder || ''}
          onChange={e => callBack(e.currentTarget.value)}
          className={b({ sizable: size, type, unBorder, centerText })}
          required={isRequired}
          {...props}
        />
        <span className={b('label-text').mix([b('transparent-text')])}>{label}</span>
        {label && <div className={b('label')}>
          <span className={b('transparent-text')}>{value}</span>
          <span className={b('label-text')}>{label}</span>
        </div>}
      </React.Fragment>
};

//Styles for selector
const customStyles = {
  menu: (provided, state) => ({
    ...provided,
    color: '#FFFFFFF',
    background: 'var(--main-background)',
  }),

  control: (provided, state) => ({
    ...provided,
    color: 'var(--accent-color)',
    background: 'transparent',
    borderColor: 'var(--text)',
    borderRadius: '0',
    maxHeight: '35px',
    minHeight: '35px',
  }),

  singleValue: (provided, state) => ({
    ...provided,
    color: 'var(--text)',
  }),

  dropdownIndicator: (provided, state) => ({
    ...provided,
    background: 'transparent',
  }),

  option: (provided, state) => ({
    ...provided,
    background: state.isSelected ? 'var(--accent-color)' : 'var(--main-background)',
  }),
}

export default Input;
